import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var TextNoteDialogComponent = /** @class */ (function () {
    function TextNoteDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.canceltext = data.CancelText || 'Cancel';
        this.oktext = data.OKText || 'OK';
        this.title = data.TitleText || 'Optional Note';
        this.message = data.MessageText || '';
        this.note = data.Note || '';
        this.noterequired = data.NoteRequired != null ? data.NoteRequired : false;
        this.placeholderText = data.PlaceholderText || 'Enter text here...';
        this.showIcon = data.ShowIcon != null ? data.ShowIcon : false;
        this.textLimit = data.TextLimit || -1;
    }
    TextNoteDialogComponent.prototype.ngOnInit = function () { };
    TextNoteDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close({
            Message: this.note,
        });
    };
    TextNoteDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    return TextNoteDialogComponent;
}());
export { TextNoteDialogComponent };
// #region Custom Classes
// #region Base Text Note Dialog Options Class
var BaseTextNoteDialogOptions = /** @class */ (function () {
    function BaseTextNoteDialogOptions() {
    }
    return BaseTextNoteDialogOptions;
}());
export { BaseTextNoteDialogOptions };
// #endregion
// #region Base Text Note Dialog Result Class
var BaseTextNoteDialogResult = /** @class */ (function () {
    function BaseTextNoteDialogResult() {
    }
    return BaseTextNoteDialogResult;
}());
export { BaseTextNoteDialogResult };
// #endregion
// #endregion
